import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";

import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import "./Stepper.css"; // Custom CSS for the stepper
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Modal, Button, Pagination } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import "./hm-theme.css";

function BookAnAppointmentForFamily() {
  const [labs, setLabs] = useState([]);
  const [tests, setTests] = useState(null);
  const [selectedLab, setSelectedLab] = useState(null);
  const [medallBranches, setMedallBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchLoader, setBranchLoader] = useState(false);
  const [branchSearchTerm, setBranchSearchTerm] = useState("");
  const [selectedTest, setSelectedTest] = useState(""); // State for selected test
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(true);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [companyData, setCompanyData] = useState(true);
  const navigate = useNavigate();
  const { familyid } = useParams();
  const [employee, setEmployee] = useState("");
  const [packages, setPackages] = useState("");
  const [packageId, setPackageId] = useState(null);
  const [packagePrice, setPackagePrice] = useState(0);
  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [labTests, setLabTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [bmiScore, setBmiScore] = useState(null);
  const [apiRecommendedTests, setApiRecommendedTests] = useState([]);
  const [familyMember, setFamilyMember] = useState(null);
  const [showTestDropdown, setShowTestDropdown] = useState(false);
  const [homeCollection, setHomeCollection] = useState(false);
  const [packageTests, setPackageTests] = useState([]);
  const [homeCollectionAvailable, setHomeCollectionAvailable] = useState(null);
  const [bookingCategories, setBookingCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedPackageType, setSelectedPackageType] = useState("Initial");
  const userid = JSON.parse(localStorage.getItem("data")).userid;
  const token = JSON.parse(localStorage.getItem("data")).token;

  const isMedallLab = (lab) => {
    if (!lab) return false;
    const name = (lab.labname || lab.name || "").trim().toLowerCase();
    return name.startsWith("medall");
  };

  const fetchMedallBranches = async () => {
    if (!selectedLab?.id) return;
    setBranchLoader(true);
    try {
      // Backend resolves labCorporateId, API URL, and auth credentials from DB
      const response = await axios.get(
        `/api/third-party-lab/${selectedLab.id}/branches`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const list = Array.isArray(response.data) ? response.data : [];

      setMedallBranches(list);
      if (list.length > 0) {
        setSelectedBranch(list[0]);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      toast.error("Failed to load branches.");
    } finally {
      setBranchLoader(false);
    }
  };

  useEffect(() => {
    if (isMedallLab(selectedLab)) {
      fetchMedallBranches();
    } else {
      setMedallBranches([]);
      setSelectedBranch(null);
    }
  }, [selectedLab]);
  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  // Helper to compute age from DOB string (YYYY-MM-DD)
  const computeAge = (dob) => {
    if (!dob) return null;
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const fetchRecommendationsByRules = async (bmiVal, ageVal) => {
    if (!companyData || !companyData.id) return;
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const requestData = {
        companyId: companyData.id,
        age: ageVal,
        bmi: companyData.bmiCalculator ? bmiVal : null,
      };

      console.log("Calling byRules API with request body:", requestData);
      const resp = await axios.post(`/api/recommendationruletests/byRules`, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("byRules API response:", resp.data);
      setApiRecommendedTests(resp.data.recommendedTests || []);
    } catch (e) {
      console.error("Error fetching recommended tests by rules", e);
    }
  };

  // Trigger recommendation fetching when familyMember, companyData settings, or weight/height inputs change
  useEffect(() => {
    if (familyMember && companyData && companyData.id) {
      const age = computeAge(familyMember.dob);
      let bmi = null;
      if (companyData.bmiCalculator && weight && height) {
        const hInMeters = parseFloat(height) / 100;
        const wInKg = parseFloat(weight);
        if (hInMeters > 0 && wInKg > 0 && weight.toString().length > 1 && height.toString().length > 1) {
          bmi = parseFloat((wInKg / (hInMeters * hInMeters)).toFixed(2));
          setBmiScore(bmi);
        } else {
          setBmiScore(null);
        }
      } else {
        setBmiScore(null);
      }

      const timeout = setTimeout(() => {
        fetchRecommendationsByRules(bmi, age);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [familyMember, companyData, weight, height]);

  // Map API recommended tests to full labTest objects from the catalog
  const combinedRecommendedTests = apiRecommendedTests
    .map((rt) => {
      const fullTest = labTests.find((lt) => lt.id === Number(rt.testId));
      if (fullTest) {
        return {
          ...fullTest,
          ruleName: rt.ruleName,
        };
      }
      return null;
    })
    .filter(Boolean);

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/labdetails/searchLabsForAppointment/regulated=true/empUserid=${userid}`;
      const requestData = {
        searchTerm,
      };
      const response = await axios.post(searchUrl, requestData, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` }, // Authorization header
      });

      setLabs(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const trans = await axios.get(`/api/labdetails/getAllLabsForAppointment/regulated=true/empUserid=${userid}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLabs(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const fetchPackage = async () => {
    setLoader(true);
    try {
      const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployee(empRes.data);

      const compRes = await axios.get(`/api/companydetails/${empRes.data?.companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanyData(compRes.data);

      if (compRes.data?.packageByCategory === true) {
        try {
          const catRes = await axios.get(
            `/api/bookingcategory/companyId=${empRes.data?.companyId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const cats = catRes.data || [];
          setBookingCategories(cats);
          if (cats.length > 0) {
            setSelectedCategoryId(cats[0].id);
          }
        } catch (_) {}
      }

      // Fetch family member details
      const famRes = await axios.get(`/api/familydetails/${familyid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFamilyMember(famRes.data);

      const testRes = await axios.get(`/api/labtest`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabTests(testRes.data);

      if (compRes.data.packageByAge === false && compRes.data.restrictedPkgByDesignation === false) {
        const pkgResponse = await axios.get(`/api/package/companyId=${empRes.data?.companyId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPackages(pkgResponse.data || []);
      } else {
        const response = await axios.get(`/api/packagedesignationmapping/employee=${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data && response.data.length > 0) {
          const mappedPackages = response.data.map(m => m.pac).filter(Boolean);
          setPackages(mappedPackages);
          if (response.data.length === 1) {
            const mapping = response.data[0];
            setTests(mapping.pac?.packagename);
            setPackageId(mapping.packageid);
            setPackagePrice(mapping.pac?.price || 0);
            try {
              const mappingRes = await axios.get(
                `/api/packagetestmapping/packageid=${mapping.packageid}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              const pkgTestList = mappingRes.data || [];
              setPackageTests(pkgTestList);
              if (compRes.data?.homeCollection === true) {
                const anyLabMandatory = pkgTestList.some(t => t.lab?.labMandatory === true);
                setHomeCollectionAvailable(!anyLabMandatory);
              }
            } catch (_) {}
          } else {
            setTests(null);
            setPackageId(null);
            setPackagePrice(0);
          }
        } else {
          try {
            const pkgResponse = await axios.get(`/api/package/companyId=${empRes.data?.companyId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            setPackages(pkgResponse.data || []);
          } catch (_) {
            setPackages([]);
          }
          setTests(null);
          setPackageId(null);
          setPackagePrice(0);
        }
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };


  const handlePackageSelection = async (e) => {
    const selectedPackageId = e.target.value;
    setPackageId(selectedPackageId);
    setHomeCollection(false);
    setHomeCollectionAvailable(null);
    setPackageTests([]);

    if (!selectedPackageId) {
      setTests(null);
      setPackagePrice(0);
      return;
    }

    try {
      setLoader(true);
      const [pkgRes, mappingRes] = await Promise.all([
        axios.get(`/api/package/${selectedPackageId}`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`/api/packagetestmapping/packageid=${selectedPackageId}`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setTests(pkgRes.data.packagename);
      setPackagePrice(pkgRes.data.price || 0);
      const pkgTestList = mappingRes.data || [];
      setPackageTests(pkgTestList);
      if (companyData?.homeCollection === true) {
        const anyLabMandatory = pkgTestList.some(t => t.lab?.labMandatory === true);
        setHomeCollectionAvailable(!anyLabMandatory);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
      else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  useEffect(() => {
    getData();
    fetchPackage();
  }, []);

  const handleConfirmation = async () => {
    if (isMedallLab(selectedLab) && !selectedBranch) {
      toast.warn("Please select a Medall branch");
      return;
    }

    // --- Field validations ---
    if (companyData.pilotOrganization === true) {
      // Validation only for pilot organizations
      if (!date && (packageId || selectedTests.length > 0)) {
        toast.warn("Please select a date");
        return;
      }

      if (!packageId && selectedTests.length === 0 && date) {
        toast.warn("Please select a package or at least one test");
        return;
      }

      if (!packageId && selectedTests.length === 0 && !date) {
        toast.warn("Please select a date and package or tests");
        return;
      }
    } else {
      // Validation for non-pilot organizations (only date required)
      if (!date) {
        toast.warn("Please select a date");
        return;
      }
    }
    // --- Date validation ---
    const selectedDate = new Date(date);
    const currentDate = new Date();

    // Remove time portion for accurate date comparison
    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const oneDayFromNow = new Date(currentDate);
    oneDayFromNow.setDate(currentDate.getDate() + 1);

    if (selectedDate < oneDayFromNow || selectedDate.getDay() === 0) {
      toast.warn(
        "Please select a weekday other than Sunday and ensure the date is at least 1 day from today."
      );
      return;
    }

    // --- Proceed to next step ---
    if (companyData.requireFamilyPayment === true) {
      setShowDescriptionModal(true);
    } else {
      setShowConfirmationModal(true);
    }
  };

  const handleConfirm = async () => {

    setShowConfirmationModal(true);

  };
  const handleProceed = async () => {
    if (isMedallLab(selectedLab) && !selectedBranch) {
      toast.warn("Please select a Medall branch");
      return;
    }

    if (companyData.pilotOrganization === true) {
      if (!date && (packageId || selectedTests.length > 0)) {
        toast.warn("Please select a date");
        return;
      }
      if (!packageId && selectedTests.length === 0 && date) {
        toast.warn("Please select a package or at least one test");
        return;
      }
      if (!packageId && selectedTests.length === 0 && !date) {
        toast.warn("Please select a date and package or tests");
        return;
      }
    } else {
      if (!date && packageId) {
        toast.warn("Please select a date");
        return;
      }
      if (!packageId && date) {
        toast.warn("Please select a package");
        return;
      }
      if (!packageId && !date) {
        toast.warn("Please select a date and package");
        return;
      }
    }

    // ✅ Step 2: Proceed only if validation passes
    if (companyData.requireFamilyPayment === true) {
      const data = {
        packageId: packageId || null,
        selectedTests: selectedTests.length > 0 ? selectedTests : null,
        userid: userid,
        familyid: familyid,
        labId: selectedLab.id,
        appointmentDate: date,
        homeCollection,
        branchId: selectedBranch?.BranchId || null,
        branchCode: selectedBranch?.BranchCode || null,
        branchName: selectedBranch?.BranchName || null,
        branchAddress: selectedBranch?.Address || null,
      };
      navigate("/users/razorpay", { state: data });
    } else {
      try {
        setLoader(true);
        await axios.post(
          "/api/employeeappointment/create",
          {
            userid: userid,
            familyid: familyid,
            labId: selectedLab.id,
            date,
            packageid: packageId,
            additionalTest: selectedTests,
            homeCollection,
            branchId: selectedBranch?.BranchId || null,
            branchCode: selectedBranch?.BranchCode || null,
            branchName: selectedBranch?.BranchName || null,
            branchAddress: selectedBranch?.Address || null,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success("Appointment Booked successfully");
        navigate(`/users/family-profile/${familyid}`);
      } catch (error) {
        setLoader(false);
        handleError(error);
      } finally {
        setShowConfirmationModal(false);
      }
    }
  };

  // ✅ Handle adding new tests
  const handleTestCheckboxChange = (testIdStr, isChecked) => {
    if (isChecked) {
      if (!selectedTests.some(t => t.testId === Number(testIdStr))) {
        const rec = apiRecommendedTests.find((rt) => Number(rt.testId) === Number(testIdStr));
        const testSource = rec ? "Recommended" : "Manual";
        const ruleId = rec ? rec.ruleId : null;
        const ruleName = rec ? rec.ruleName : null;
        setSelectedTests((prev) => [...prev, { testId: Number(testIdStr), testSource, ruleId, ruleName }]);
      }
    } else {
      setSelectedTests((prev) => prev.filter((t) => t.testId !== Number(testIdStr)));
    }
  };

  // ✅ Remove selected test
  const handleRemoveTest = (id) => {
    setSelectedTests((prev) => prev.filter((t) => t.testId !== Number(id)));
  };


  const handleUseMyLocation = async (pageNumber = 0) => {
    setLoader(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const response = await axios.get(`/api/labdetails/nearByLocation`, {
            params: {
              latitude,
              longitude,
              radius: 10,
              empUserid: userid,
              page: pageNumber
            },
            headers: { Authorization: `Bearer ${token}` }
          });

          setLabs(response.data.content); // Only set the labs, not the entire page object
          setCurrentPage(response.data.number);
          setTotalPages(response.data.totalPages);
          setLoader(false);
        } catch (error) {
          setLoader(false);
          handleError(error);
        }

      }, error => {
        handleError(error);
        setLoader(false);
      });
    } else {
      setLoader(false);
      toast.error("Geolocation is not supported by this browser.");
    }
  };  const renderStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <div className="hm-card mb-4">
            <div className="hm-card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
              <h3 className="hm-card-title m-0">
                <i className="material-icons">domain</i>
                Choose Lab
              </h3>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div className="position-relative" style={{ width: "280px" }}>
                  <input
                    type="search"
                    className="form-control ps-5"
                    placeholder="Search lab, code, city, pincode"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <FontAwesomeIcon
                    icon={faSearch}
                    className="position-absolute text-muted"
                    style={{ left: "14px", top: "50%", transform: "translateY(-50%)" }}
                  />
                </div>
                <Button
                  variant="outline-primary"
                  className="rounded-pill btn-sm d-flex align-items-center gap-1 px-3 py-2"
                  onClick={() => handleUseMyLocation(0)}
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} /> Use My Location
                </Button>
              </div>
            </div>

            <div className="hm-card-body p-4">
              <div className="row g-4 mb-4">
                {labs.length === 0 ? (
                  <div className="col-12">
                    <div className="hm-empty-state py-5">
                      <i className="material-icons">search_off</i>
                      <p>No Diagnostic Labs Found</p>
                    </div>
                  </div>
                ) : (
                  labs.map((lab) => {
                    const isSelected = selectedLab && selectedLab.id === lab.id;
                    return (
                      <div className="col-md-6 col-lg-4" key={lab.id}>
                        <div
                          className={`hm-card h-100 p-0 border transition-all cursor-pointer ${
                            isSelected
                              ? "border-primary shadow"
                              : "border-light shadow-sm hover-shadow"
                          }`}
                          onClick={() => setSelectedLab(lab)}
                          style={{
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            borderColor: isSelected ? "#2f3a88" : undefined,
                            borderWidth: isSelected ? "2px" : "1px"
                          }}
                        >
                          {lab.image && (
                            <img
                              src={lab.image}
                              className="card-img-top"
                              alt={lab.labname}
                              style={{ height: "140px", objectFit: "cover" }}
                            />
                          )}
                          <div className="p-3">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <h5 className="fw-bold mb-0 text-truncate" style={{ color: "#1e293b", fontSize: "1rem" }}>
                                {lab.labname}
                              </h5>
                              <span className="badge bg-primary bg-opacity-10 text-primary small">
                                {lab.labcode}
                              </span>
                            </div>
                            <p className="text-muted small mb-1">
                              <i className="material-icons align-middle me-1" style={{ fontSize: "0.9rem" }}>phone</i>
                              {lab.contact}
                            </p>
                            <p className="text-muted small mb-0">
                              <i className="material-icons align-middle me-1" style={{ fontSize: "0.9rem" }}>location_on</i>
                              {lab.addressLine1}, {lab.city}, {lab.pincode}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* ── Medall Diagnostic Branches Display ── */}
              {isMedallLab(selectedLab) && (
                <div className="medall-branch-container mb-4">
                  <div className="medall-branch-header">
                    <div>
                      <h4 className="medall-branch-title">
                        <i className="material-icons text-primary">storefront</i>
                        Medall Diagnostic Branches
                      </h4>
                      <p className="text-muted small mb-0">
                        Selected Lab: <strong>{selectedLab.labname}</strong> &mdash; Choose your branch location below:
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <div className="position-relative" style={{ width: "260px" }}>
                        <input
                          type="search"
                          className="form-control form-control-sm ps-4"
                          placeholder="Search branch, city, pincode..."
                          value={branchSearchTerm}
                          onChange={(e) => setBranchSearchTerm(e.target.value)}
                        />
                        <FontAwesomeIcon
                          icon={faSearch}
                          className="position-absolute text-muted"
                          style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "11px" }}
                        />
                      </div>
                      <span className="badge bg-primary bg-opacity-10 text-primary small py-2 px-3 rounded-pill">
                        {medallBranches.length} Branches Available
                      </span>
                    </div>
                  </div>

                  {branchLoader ? (
                    <div className="d-flex align-items-center justify-content-center py-4 gap-2 text-primary">
                      <div className="spinner-border spinner-border-sm" role="status"></div>
                      <span className="small fw-semibold">Loading Medall branch list...</span>
                    </div>
                  ) : (
                    (() => {
                      const filtered = medallBranches.filter((b) => {
                        if (!branchSearchTerm.trim()) return true;
                        const term = branchSearchTerm.toLowerCase();
                        return (
                          (b.BranchName || "").toLowerCase().includes(term) ||
                          (b.BranchCode || "").toLowerCase().includes(term) ||
                          (b.CityName || "").toLowerCase().includes(term) ||
                          (b.Address || "").toLowerCase().includes(term) ||
                          (b.Pincode || "").toLowerCase().includes(term)
                        );
                      });

                      if (filtered.length === 0) {
                        return (
                          <div className="text-center py-4 text-muted small">
                            <i className="material-icons d-block mb-1" style={{ fontSize: "2rem" }}>search_off</i>
                            No branches found matching "{branchSearchTerm}"
                          </div>
                        );
                      }

                      return (
                        <div className="medall-branch-grid">
                          {filtered.map((branch) => {
                            const isBranchSelected =
                              selectedBranch && String(selectedBranch.BranchId) === String(branch.BranchId);
                            return (
                              <div
                                key={branch.BranchId}
                                className={`medall-branch-card ${isBranchSelected ? "selected" : ""}`}
                                onClick={() => setSelectedBranch(branch)}
                              >
                                <div>
                                  <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                                    <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: "0.95rem" }}>
                                      {branch.BranchName}
                                    </h6>
                                    <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                      {branch.BranchClassificationName && (
                                        <span className="badge bg-secondary bg-opacity-10 text-secondary small py-1 px-2 rounded-pill" style={{ fontSize: "0.7rem" }}>
                                          {branch.BranchClassificationName}
                                        </span>
                                      )}
                                      <span className="medall-branch-badge">
                                        Code: {branch.BranchCode}
                                      </span>
                                    </div>
                                  </div>

                                  <p className="text-muted small mb-1" style={{ fontSize: "0.82rem", lineHeight: "1.4" }}>
                                    <i className="material-icons align-middle text-primary me-1" style={{ fontSize: "0.95rem" }}>location_on</i>
                                    {branch.Address}
                                  </p>

                                  <div className="d-flex align-items-center gap-3 text-muted small mt-2" style={{ fontSize: "0.78rem" }}>
                                    {branch.CityName && (
                                      <span>
                                        <strong className="text-dark">City:</strong> {branch.CityName}
                                      </span>
                                    )}
                                    {branch.Pincode && (
                                      <span>
                                        <strong className="text-dark">PIN:</strong> {branch.Pincode}
                                      </span>
                                    )}
                                  </div>

                                  {branch.ContactNo && (
                                    <div className="text-muted small mt-1" style={{ fontSize: "0.78rem" }}>
                                      <i className="material-icons align-middle text-muted me-1" style={{ fontSize: "0.85rem" }}>phone</i>
                                      {branch.ContactNo}
                                    </div>
                                  )}
                                </div>

                                <div className="mt-3 pt-2 border-top d-flex align-items-center justify-content-between">
                                  <span className="small fw-semibold" style={{ color: isBranchSelected ? "#2563eb" : "#64748b" }}>
                                    {isBranchSelected ? "✓ Selected Branch" : "Click to select"}
                                  </span>
                                  <button
                                    type="button"
                                    className={`btn btn-sm rounded-pill px-3 ${
                                      isBranchSelected ? "btn-primary shadow-sm" : "btn-outline-primary"
                                    }`}
                                    style={{ fontSize: "0.75rem", pointerEvents: "none" }}
                                  >
                                    {isBranchSelected ? "Selected" : "Select"}
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()
                  )}
                </div>
              )}

              <div className="d-flex justify-content-center mb-4">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(0)}
                    disabled={currentPage === 0}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 0}
                  />
                  {renderPageNumbers()}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages - 1}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages - 1)}
                    disabled={currentPage === totalPages - 1}
                  />
                </Pagination>
              </div>

              <div className="d-flex justify-content-end pt-3 border-top">
                <button
                  className="btn-hm-primary px-4"
                  onClick={() => {
                    if (isMedallLab(selectedLab) && !selectedBranch) {
                      toast.warn("Please select a Medall branch to continue.");
                      return;
                    }
                    setStep(2);
                  }}
                  disabled={!selectedLab || (isMedallLab(selectedLab) && !selectedBranch)}
                >
                  Next Step ➔
                </button>
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">event_note</i>
                Book Family Member Appointment
              </h3>
            </div>

            <div className="hm-card-body p-4">
              {selectedLab && (
                <div className="row g-4">
                  {/* Left Column */}
                  <div className="col-md-6 border-end pe-md-4">
                    <div className="p-3 bg-light rounded mb-4">
                      <p className="mb-1 small">
                        <strong className="text-dark">Selected Lab:</strong> {selectedLab.labname}
                      </p>
                      {selectedBranch && (
                        <p className="mb-1 small">
                          <strong className="text-dark">Selected Branch:</strong>{" "}
                          <span className="text-primary fw-semibold">{selectedBranch.BranchName}</span> ({selectedBranch.BranchCode})
                          {selectedBranch.Address && <span className="text-muted d-block small mt-1">{selectedBranch.Address}</span>}
                        </p>
                      )}
                      <p className="mb-0 small">
                        <strong className="text-dark">Selected Package:</strong> {tests || "None"}{" "}
                        {companyData?.pilotOrganization === true && packagePrice > 0 ? `(₹${packagePrice})` : ""}
                        {tests !== null && (
                          <FiInfo
                            onClick={() => openTestsModal(packageId)}
                            className="text-primary ms-2 cursor-pointer"
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </p>
                    </div>

                    {isMedallLab(selectedLab) && medallBranches.length > 0 && (
                      <div className="mb-4 p-3 rounded-3 border bg-white shadow-sm">
                        <label htmlFor="medallBranchSelectFam" className="form-label small fw-semibold text-primary mb-2 d-flex align-items-center gap-1">
                          <i className="material-icons" style={{ fontSize: "1rem" }}>storefront</i>
                          Select / Change Medall Branch <span className="text-danger">*</span>
                        </label>
                        <select
                          id="medallBranchSelectFam"
                          className="form-select"
                          value={selectedBranch ? selectedBranch.BranchId : ""}
                          onChange={(e) => {
                            const found = medallBranches.find(b => String(b.BranchId) === String(e.target.value));
                            setSelectedBranch(found || null);
                          }}
                        >
                          {medallBranches.map((b) => (
                            <option key={b.BranchId} value={b.BranchId}>
                              {b.BranchName} ({b.BranchCode}) - {b.CityName || ""}{b.Pincode ? ` - PIN ${b.Pincode}` : ""}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {companyData?.packageByCategory === true ? (
                      <div>
                        {/* Category Navigation Bar (Pilots, Cabin Crew, FATA Pilots, ATCOs) */}
                        <div className="mb-4">
                          <label className="form-label small fw-semibold text-muted text-uppercase tracking-wider mb-2">
                            Category Selection
                          </label>
                          <div className="d-flex flex-wrap gap-2">
                            {bookingCategories.map((cat) => {
                              const isSelected = String(cat.id) === String(selectedCategoryId);
                              const catName = cat.name || cat.categoryname;
                              return (
                                <button
                                  key={cat.id}
                                  type="button"
                                  className={`btn ${
                                    isSelected
                                      ? "btn-primary shadow-sm"
                                      : "btn-outline-primary"
                                  } rounded-pill px-4 py-2 d-flex align-items-center gap-2 fw-semibold`}
                                  onClick={() => {
                                    setSelectedCategoryId(cat.id);
                                    handlePackageSelection({ target: { value: "" } });
                                  }}
                                >
                                  <i className="material-icons" style={{ fontSize: "1.1rem" }}>
                                    {catName?.toLowerCase().includes("pilot") ? "flight" :
                                     catName?.toLowerCase().includes("crew") ? "badge" :
                                     catName?.toLowerCase().includes("atco") ? "radar" : "category"}
                                  </i>
                                  {catName}
                                </button>
                              );
                            })}
                          </div>
                        </div>

                        {/* Package Type Pills (Initial / Renewal) */}
                        {selectedCategoryId && (
                          <div className="mb-4">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <h5 className="fw-bold mb-0 text-dark">
                                {bookingCategories.find(c => String(c.id) === String(selectedCategoryId))?.name ||
                                 bookingCategories.find(c => String(c.id) === String(selectedCategoryId))?.categoryname || "Category"}
                              </h5>
                              <span className="small text-muted">Select Initial or Renewal</span>
                            </div>
                            <div className="bg-light p-1 rounded-pill d-inline-flex gap-1 border" style={{ maxWidth: "280px", width: "100%" }}>
                              {["Initial", "Renewal"].map((type) => {
                                const isTypeActive = selectedPackageType === type;
                                return (
                                  <button
                                    key={type}
                                    type="button"
                                    className={`btn btn-sm flex-fill rounded-pill py-2 ${
                                      isTypeActive
                                        ? "btn-primary shadow-sm fw-bold"
                                        : "btn-light text-muted border-0"
                                    }`}
                                    onClick={() => {
                                      setSelectedPackageType(type);
                                      handlePackageSelection({ target: { value: "" } });
                                    }}
                                  >
                                    {type}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {/* Package Cards or Selected Package Details */}
                        {!packageId ? (
                          <div className="mb-4">
                            <label className="form-label small fw-semibold text-muted mb-2">
                              Select Medical Package ({selectedPackageType})
                            </label>
                            {(() => {
                              const categoryPackages = (Array.isArray(packages) ? packages : []).filter(
                                (pkg) =>
                                  (Array.isArray(pkg.bookingCategoryIds)
                                    ? pkg.bookingCategoryIds.map(String).includes(String(selectedCategoryId))
                                    : String(pkg.bookingCategoryId) === String(selectedCategoryId)) &&
                                  (!selectedPackageType || pkg.packageType === selectedPackageType)
                              );

                              if (categoryPackages.length === 0) {
                                return (
                                  <div className="p-4 border rounded-3 bg-light text-center">
                                    <i className="material-icons text-muted fs-1 mb-2">event_busy</i>
                                    <p className="text-muted small mb-0">
                                      No packages found for {selectedPackageType} under this category.
                                    </p>
                                  </div>
                                );
                              }

                              return (
                                <div className="row g-3">
                                  {categoryPackages.map((pkg) => (
                                    <div className="col-12" key={pkg.id}>
                                      <div
                                        className="p-3 border rounded-3 bg-white shadow-sm hover-shadow cursor-pointer transition-all d-flex align-items-center justify-content-between"
                                        onClick={() => handlePackageSelection({ target: { value: pkg.id } })}
                                        style={{ cursor: "pointer", transition: "all 0.2s" }}
                                      >
                                        <div>
                                          <h6 className="fw-bold mb-1 text-primary">{pkg.packagename}</h6>
                                          {pkg.description && (
                                            <p className="text-muted small mb-1">{pkg.description}</p>
                                          )}
                                          {pkg.price > 0 && (
                                            <span className="badge bg-success bg-opacity-10 text-success fw-bold">
                                              ₹{pkg.price}
                                            </span>
                                          )}
                                        </div>
                                        <i className="material-icons text-primary">chevron_right</i>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              );
                            })()}
                          </div>
                        ) : (
                          <div className="mb-4 p-3 border rounded-3 bg-light shadow-sm">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                              <div>
                                <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 mb-1 px-3 py-1 rounded-pill small">
                                  {selectedPackageType} Medical
                                </span>
                                <h6 className="fw-bold text-dark mb-1">{tests}</h6>
                                {packagePrice > 0 && (
                                  <span className="text-success fw-bold small">Total Price: ₹{packagePrice}</span>
                                )}
                              </div>
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm rounded-pill px-3"
                                onClick={() => handlePackageSelection({ target: { value: "" } })}
                              >
                                Change
                              </button>
                            </div>

                            {/* Investigations Included */}
                            <div className="p-3 bg-white border rounded-3">
                              <h6 className="fw-bold small text-dark mb-2 d-flex align-items-center gap-1">
                                <i className="material-icons text-primary" style={{ fontSize: "1rem" }}>checklist</i>
                                Investigations Included ({packageTests.length})
                              </h6>
                              {packageTests.length === 0 ? (
                                <p className="small text-muted mb-0">No tests mapped to this package.</p>
                              ) : (
                                <div className="row g-2">
                                  {packageTests.map((t, idx) => (
                                    <div className="col-12" key={t.id || idx}>
                                      <div className="d-flex align-items-center gap-2 p-2 rounded bg-light border-0">
                                        <i className="material-icons text-success" style={{ fontSize: "1.1rem" }}>check_circle</i>
                                        <span className="small fw-semibold text-dark">
                                          {t.labTest?.testname || t.testname || "Lab Test"}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : packages && packages.length > 0 ? (
                      <div className="mb-4">
                        <label htmlFor="package" className="form-label small fw-semibold">
                          Select Package <span className="text-danger">*</span>
                        </label>
                        <select id="package" className="form-select" value={packageId || ""} onChange={handlePackageSelection}>
                          <option value="">-- Select Package --</option>
                          {packages.map((pkg) => (
                            <option key={pkg.id} value={pkg.id}>
                              {pkg.packagename} {companyData?.pilotOrganization === true && pkg.price > 0 ? `- ₹${pkg.price}` : ""}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}

                    <div className="mb-4 position-relative">
                      <label className="form-label small fw-semibold">Select Additional Tests</label>
                      <div
                        className="form-select d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowTestDropdown(!showTestDropdown)}
                      >
                        <span className="text-muted small">
                          {selectedTests.filter(t => t.testSource === "Manual").length > 0
                            ? `${selectedTests.filter(t => t.testSource === "Manual").length} test(s) selected`
                            : "-- Select tests --"}
                        </span>
                        <span style={{ fontSize: "10px" }}>{showTestDropdown ? "▲" : "▼"}</span>
                      </div>
                      {showTestDropdown && (
                        <div
                          className="border rounded p-2 shadow-sm bg-white"
                          style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            position: "absolute",
                            zIndex: 10,
                            width: "100%",
                            marginTop: "2px",
                          }}
                        >
                          {labTests.map((test) => {
                            const isChecked = selectedTests.some(t => t.testId === test.id);
                            const isRecommended = apiRecommendedTests.some((rt) => Number(rt.testId) === Number(test.id));
                            return (
                              <div key={test.id} className="form-check mb-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`test-${test.id}`}
                                  checked={isChecked}
                                  onChange={(e) => handleTestCheckboxChange(test.id, e.target.checked)}
                                />
                                <label className="form-check-label small ms-2" htmlFor={`test-${test.id}`}>
                                  {test.testname} - {test.testCat?.categoryname}{" "}
                                  {test.testCost?.cost ? `- ₹${test.testCost.cost}` : ""}
                                  {isRecommended && <span className="badge bg-warning text-dark ms-2 small">Recommended</span>}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    <div className="mb-4">
                      <label htmlFor="date" className="form-label small fw-semibold">
                        Select Date <span className="text-danger">*</span>
                      </label>
                      <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
                    </div>

                    {selectedTests.length > 0 && (
                      <div className="mb-4">
                        <h6 className="fw-bold small mb-2 text-dark">Selected Tests</h6>
                        <div className="d-flex flex-wrap gap-2">
                          {selectedTests.map((item) => {
                            const id = item.testId;
                            const selectedTest = labTests.find((t) => t.id === Number(id));
                            return (
                              <span
                                key={id}
                                className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-3 py-2 rounded-pill small cursor-pointer d-flex align-items-center gap-1"
                                onClick={() => handleRemoveTest(id)}
                              >
                                {selectedTest?.testname || "Test"} ✕
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {/* Home Collection — only shown when company has homeCollection enabled */}
                    {companyData?.homeCollection === true && (packageId || selectedTests.length > 0) && homeCollectionAvailable !== null && (
                      <div className="mb-4">
                        <label className="form-label small fw-semibold d-block">Home Collection</label>
                        {homeCollectionAvailable && !selectedTests.some((st) => labTests.find((lt) => lt.id === Number(st.testId))?.labMandatory === true) ? (
                          <div
                            className="d-flex align-items-center justify-content-between p-2 rounded"
                            style={{ background: "#f0fdf4", border: "1px solid #86efac" }}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <i className="material-icons" style={{ color: "#16a34a", fontSize: "1.1rem" }}>home</i>
                              <span className="small fw-semibold" style={{ color: "#15803d" }}>
                                Home Collection is Available
                              </span>
                            </div>
                            <div className="form-check form-switch m-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="homeCollectionCheckboxFamily"
                                checked={homeCollection}
                                onChange={(e) => setHomeCollection(e.target.checked)}
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-2 p-2 rounded" style={{ background: "#fef2f2", border: "1px solid #fecaca" }}>
                            <i className="material-icons" style={{ color: "#dc2626", fontSize: "1.1rem" }}>home_work</i>
                            <span className="small text-danger fw-semibold">Home collection not available — visit the lab</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Right Column: BMI Calculator & Recommendations */}
                  <div className="col-md-6 ps-md-4">
                    {companyData?.bmiCalculator && (
                      <div className="p-3 rounded border bg-light mb-4">
                        <h6 className="fw-bold small mb-3 text-dark">BMI Calculator</h6>
                        <div className="row g-3">
                          <div className="col-6">
                            <label htmlFor="weight" className="form-label small fw-semibold">Weight (kg)</label>
                            <input
                              type="number"
                              id="weight"
                              className="form-control form-control-sm"
                              placeholder="e.g. 70"
                              value={weight}
                              onChange={(e) => setWeight(e.target.value)}
                            />
                          </div>
                          <div className="col-6">
                            <label htmlFor="height" className="form-label small fw-semibold">Height (cm)</label>
                            <input
                              type="number"
                              id="height"
                              className="form-control form-control-sm"
                              placeholder="e.g. 175"
                              value={height}
                              onChange={(e) => setHeight(e.target.value)}
                            />
                          </div>
                          <div className="col-12">
                            {bmiScore ? (
                              <div className="alert alert-success d-flex justify-content-between align-items-center m-0 py-2 border-0">
                                <span className="fw-bold small">BMI: {bmiScore}</span>
                                {apiRecommendedTests.some((rt) => rt.ruleName === "BMI") && (
                                  <span className="badge bg-danger small">Condition Matched</span>
                                )}
                              </div>
                            ) : (
                              <div className="text-muted small text-center py-2 bg-white rounded border">
                                Enter weight and height to calculate BMI
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-between pt-4 border-top mt-4">
                <Button variant="outline-secondary" className="rounded-pill px-4" onClick={() => setStep(1)}>
                  ◄ Back
                </Button>
                <button className="btn-hm-primary px-4" onClick={handleConfirmation}>
                  Proceed
                </button>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <AdminDashboard />
      {loader && <div className="loading"></div>}

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">event</i>
                Book Family Member Appointment
              </h2>
              <p className="hm-page-subtitle">
                Select a diagnostic lab center and configure family member medical appointment details.
              </p>
            </div>
          </div>

          {/* Stepper Header */}
          <div className="d-flex align-items-center justify-content-center gap-4 mb-4 pb-3 border-bottom">
            <div
              className={`d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold ${
                step === 1
                  ? "bg-primary text-white shadow-sm"
                  : "bg-light text-secondary border"
              }`}
            >
              <span
                className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${
                  step === 1 ? "bg-white text-primary" : "bg-secondary text-white"
                }`}
                style={{ width: "24px", height: "24px", fontSize: "12px" }}
              >
                1
              </span>
              <span>Select Lab</span>
            </div>

            <div className="text-muted">➔</div>

            <div
              className={`d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold ${
                step === 2
                  ? "bg-primary text-white shadow-sm"
                  : "bg-light text-secondary border"
              }`}
            >
              <span
                className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${
                  step === 2 ? "bg-white text-primary" : "bg-secondary text-white"
                }`}
                style={{ width: "24px", height: "24px", fontSize: "12px" }}
              >
                2
              </span>
              <span>Book Appointment</span>
            </div>
          </div>

          {renderStepContent(step)}
        </div>
      </div>

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={closeTestsModal}
          packageId={selectedPackage}
        />
      )}

      <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-primary">Appointment Authorization</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="small text-muted mb-0">
            On confirmation of appointment with the selected lab{selectedBranch ? ` (${selectedBranch.BranchName})` : ""}, I hereby authorize the lab to upload the medical reports to the TMPL web portal for <strong>{companyData?.companyname}</strong>.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="outline-secondary" className="rounded-pill btn-sm px-3" onClick={() => setShowConfirmationModal(false)}>
            Cancel
          </Button>
          <button className="btn-hm-primary px-3 py-1" onClick={handleProceed}>
            Confirm & Book
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default BookAnAppointmentForFamily;
